import { Configurations, DataService, FgAppConstants, UserService } from "fg-library";

export interface Theme {
  label: string;
  class: string;
  primaryColor: string;
  accentColor: string;
  warnColor: string;
}
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
export const fingressThemes = [
    {
      label: "Fingress Red",
      class: "fingress-red-theme",
      primaryColor: "#d00a0d", // mat.$light-blue-palette[500]
      accentColor: "#2962ff", // mat.$green-palette[500]
      warnColor: "#E53935", // mat.$red-palette[600]
    },
    {
      label: "Fingress Blue",
      class: "fingress-blue-theme",
      primaryColor: "#2962ff", // mat.$light-blue-palette[500]
      accentColor: "#d00a0d", // mat.$green-palette[500]
      warnColor: "#2962ff", // mat.$red-palette[600]
    },
    {
      label: "Fingress Green",
      class: "fingress-green-theme",
      primaryColor: "#03A9F4", // mat.$light-blue-palette[500]
      accentColor: "#d00a0d", // mat.$green-palette[500]
      warnColor: "#E53935", // mat.$red-palette[600]
    },
    {
      label: "Fingress Orange",
      class: "fingress-orange-theme",
      primaryColor: "#03A9F4", // mat.$light-blue-palette[500]
      accentColor: "#4CAF50", // mat.$green-palette[500]
      warnColor: "#E53935", // mat.$red-palette[600]
    },

    {
      label: "Dark",
      class: "dark-theme",
      primaryColor: "#424242", // mat.$grey-palette[800]
      accentColor: "#FF6F00", // mat.$amber-palette[900]
      warnColor: "#F44336", // mat.$red-palette[500]
    },
  ];

  export function   extractFirstLetters(loginId: any) {
    if (loginId && loginId.includes(" ")) {
      let words = loginId.split(" ");
      let firstWord = words[0].charAt(0);
      let lastWord = words[words.length - 1].charAt(0);
      return firstWord + lastWord;
    } else if (loginId) return loginId.charAt(0);
  }

  export function  logout(directLogin: boolean = false,config:Configurations,router:Router, fgAppConstant:FgAppConstants,  userService:UserService, dataService:DataService) {
    var token = userService.getToken();
    var apiAccessToken = token.apiAccessSessionToken;
    if (!fgAppConstant["StudioUtills"].isUndefined(apiAccessToken)) {
      var requestData = {
        filter: {
          token: apiAccessToken,
        },
      };
      dataService.signOut(requestData).subscribe((_response) => {
        userService.logout();
        if (
          !directLogin &&
          config?._postLogoutLandingPageId &&
          config?._postLogoutLandingAppId
        ) {
          var pageUrl =
            "page/" +
            config._postLogoutLandingPageId +
            "/" +
            config._postLogoutLandingAppId;
          router.navigateByUrl(`${pageUrl}`);
        } else goToLogin(userService,router);
      });
    }
  }

   function  goToLogin(userService:UserService, router:Router ) {
    userService.logout();
    let session = userService.isUserLoggedIn();
    if (!session)
      router.navigate(["/app/login"], { queryParams: { logout: "true" } });
  }